if ($(window).width() >= 767) {
    var display_countStockholm = 3;
    var display_countCopenhagen = 3;
    var display_countOslo = 3;
} else {
    display_countStockholm = 2;
    display_countCopenhagen = 2;
    display_countOslo = 2;
}

function showMoreStockholm(start, end) {
    for (var i = start; i < end; i++) {
        $('.post-card-stockholm').eq(i).css('display', 'block');
    }
}
function showMoreOslo(start, end) {
    for (var i = start; i < end; i++) {
        $('.post-card-oslo').eq(i).css('display', 'block');
    }
}
function showMoreCopenhagen(start, end) {
    for (var i = start; i < end; i++) {
        $('.post-card-copenhagen').eq(i).css('display', 'block');
    }
}
$('.latest-posts__show-more').click(function () {
    showMoreStockholm(display_countStockholm, display_countStockholm + 2);
    display_countStockholm += 2;
    showMoreCopenhagen(display_countCopenhagen, display_countCopenhagen + 2);
    display_countCopenhagen += 2;
    showMoreOslo(display_countOslo, display_countOslo + 2);
    display_countOslo += 2;
    if ($('.latest-posts__city').children(':hidden').length === 0) {
        $(this).hide();
    }
})

//Blog Filters
let postsPerPage = $('.show-more-posts').attr('data-postsperpage');
let newPostsPerPage;
let blogFilterCount = $(".blog-filters-main__btn").attr("data-filters-count");
if (
    $(".blog-list")
        .children()
        .hasClass("no-posts")
) {
    $(".blog-list").css("display", "block");
}
$(".blog-filters-main__btn").click(function () {
    if ($(".blog-filters-tax").is(":visible")) {
        $(".blog-filters-tax").hide();
        $('.blog-list .show-more-posts').show();
    } else {
        $(".blog-filters-tax").show();
        $('.blog-list .show-more-posts').hide();
    }

    $(".blog-wrapper").toggleClass("overflow-archive");
    $(".blog-wrapper__main-content").toggleClass("slide-content");
    $(".blog-filters-main__btn").toggleClass("filter-click");
    if ($(this).hasClass("filter-click")) {
        $(this).text(translations.closeFilters);
    } else {
        $(this).text(translations.filters + " " + blogFilterCount);
    }
    if ($(window).width() >= 1024) {
        $(".blog-filters-main").toggleClass("max-width");
    }
});

$(".blog-filters-tax__item>span").click(function () {
    $(this)
        .next(".blog-filters-tax__terms")
        .slideToggle();
    $(this).toggleClass("slide-down");
});

const urlParams = function (name) {
    var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
        window.location.href
    );
    if (results == null) {
        return null;
    } else {
        return decodeURI(results[1]) || 0;
    }
};

function blogFilterSubmit() {
    let blogFilterData = $("#blog-filters-tax").serialize();
    let blogFilterDataArray = $("#blog-filters-tax").serializeArray();
    let blogFilterDataLength = blogFilterDataArray.length - 1;
    newPostsPerPage = $('.show-more-posts').attr('data-postsperpage');

    blogFilterCount = blogFilterDataLength !== 0 ? "(" + blogFilterDataLength + ")" : "";
    if (window.location.href.indexOf("page") > -1) {
        window.history.replaceState({}, document.title, "/tours/?" + blogFilterData);
    }
    window.history.replaceState({}, document.title, "?" + blogFilterData);
    $.ajax({
        type: "POST",
        url: themeVars.ajax_url,
        data: {
            action: "postsLoad",
            data: blogFilterData,
            postsPerPage: newPostsPerPage,
        },
        beforeSend: function () {
            $(".blog-list__preloader").show();
        },
        success: function (response) {
            $(".blog-list__preloader").hide();
            $(".blog-list-wrapper").html(response);
            if (parseInt(newPostsPerPage) > $('.blog-list > .blog-list__block').length) {
                $('.show-more-posts').hide();
            } else {
                $('.show-more-posts').show();
            }
            if (
                $(".blog-list")
                    .children()
                    .hasClass("no-posts")
            ) {
                $(".blog-list").css("display", "block");
            }

        },
    });
}
$(".blog-filters-main__date-option").change(function () {
    let dateValue = $(this).val();
    $('select[name="filter-sortby"]').val(dateValue);
    $("#blog-filters-tax").submit(blogFilterSubmit());
});
let sortBy = $(".blog-filters-main__date-option>option");
for (var i = 0; i < sortBy.length; i++) {
    if ($(sortBy[i]).val() == urlParams("blog-filter-sortby")) {
        $(sortBy[i]).attr("selected", "selected");
    }
}

$(".blog-filters-tax__checkbox").click(function () {
    $("#blog-filters-tax").submit(blogFilterSubmit());
});
$(".blog-filters-tax__clean").click(function () {
    if (window.location.search != 0) {
        window.location.search = "";
    }
});

$(document).on('click', '.show-more-posts', function () {
    postsPerPage = $('.show-more-posts').attr('data-postsperpage');
    newPostsPerPage = $('.show-more-posts').attr('data-postsperpage', parseInt(postsPerPage) + 6);
    $("#blog-filters-tax").submit(blogFilterSubmit());
});

if (parseInt(postsPerPage) > $('.blog-list > .blog-list__block').length) {
    $('.show-more-posts').hide();
}

$(window).resize(function () {
    if (
        $(window).width() >= 1024 &&
        $(".blog-filters-tax").css("display") == "block"
    ) {
        $(".blog-filters-main").addClass("max-width");
    } else {
        $(".blog-filters-main").removeClass("max-width");
    }
});
$('.download-block__link').click(function () {
    $(this).siblings('.download-block__form').show();
    $(this).hide();
    $(this).siblings('.download-block__thank-you').hide();
    $(this).parent().css('padding-bottom', '0px');
})
$('.download-block__form .wpcf7').on('wpcf7mailsent', function () {
    $(this).parent().hide();
    $(this).parent().siblings('.download-block__link').show();
    $(this).parent().siblings('.download-block__thank-you').show();
});


// WEBPACK FOOTER //
// ./scripts/modules/blog.js